var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M16.44 5.521c0-.84-.681-1.521-1.521-1.521H7.52C6.681 4 6 4.681 6 5.521v14.072c0 .84.681 1.522 1.521 1.522h7.398c.84 0 1.521-.681 1.521-1.522V5.521zm-8.919-.76h7.398c.42 0 .76.34.76.76v.71H6.761v-.71c0-.42.34-.76.76-.76zm8.158 2.23v10.24H6.761V6.992h8.918zm-.76 13.363H7.52a.76.76 0 0 1-.76-.76v-1.602h8.918v1.601c0 .42-.34.761-.76.761z",
    opacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.aec93023429c917ddad90e13ca2a119e.svg";
export { ForwardRef as ReactComponent };